module.exports = __webpack_public_path__ + "static/media/banner-toddler.08d68332.jpg";